// Správa souhlasu s cookies + načtení Google Analytics až po souhlasu.
const CONSENT_KEY = "alukola_cookie_consent_v1";
const GA_ID = "G-90ZN0Y0ZFW";

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveConsent(consent) {
  const data = { analytics: false, marketing: false, ...consent, ts: new Date().toISOString() };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(data));
  applyConsent(data);
  return data;
}

let gaLoaded = false;
function loadGA() {
  if (gaLoaded || !GA_ID) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

// Aplikuje uložený souhlas – analytika se načte pouze při souhlasu.
export function applyConsent(consent) {
  if (consent && consent.analytics) loadGA();
}

// Zavolat jednou při startu aplikace.
export function initConsent() {
  const c = getConsent();
  if (c) applyConsent(c);
}

// Otevření nastavení cookies z patičky.
export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent("open-cookie-settings"));
}
